import React, { useState } from 'react';
import './ConversionModal.css';

const ConversionModal = ({ rows: initialRows, onSave, onDelete, onClose }) => {
    const [rows, setRows] = useState(initialRows.length > 0 ? initialRows : [{ input: 0, output: 0 }]);

    const addRow = () => {
        setRows([...rows, { input: 0, output: 0 }]);
    };

    const removeRow = (index) => {
        if (rows.length > 1) {
            setRows(rows.filter((_, i) => i !== index));
        }
    };

    const updateRow = (index, field, value) => {
        const updated = [...rows];
        updated[index][field] = Number(value);
        setRows(updated);
    };

    const handleSave = () => {
        // Убираем пустые строки
        const nonEmpty = rows.filter(r => r.input !== '' && r.output !== '');
        onSave(nonEmpty);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>Таблица конверсии температуры</h3>
                <p>Исходное значение → Результирующее значение</p>

                <table className="conversion-table">
                    <thead>
                        <tr>
                            <th>Исходное</th>
                            <th>Результирующее</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, idx) => (
                            <tr key={idx}>
                                <td>
                                    <input
                                        type="number"
                                        step="any"
                                        value={row.input}
                                        onChange={(e) => updateRow(idx, 'input', e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        step="any"
                                        value={row.output}
                                        onChange={(e) => updateRow(idx, 'output', e.target.value)}
                                    />
                                </td>
                                <td>
                                    <button type="button" onClick={() => removeRow(idx)} className="remove-row-btn">
                                        ×
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <button type="button" onClick={addRow} className="add-row-btn">
                    + Добавить строку
                </button>

                <div className="modal-buttons">
                    <button type="button" onClick={handleSave} className="save-btn">
                        Сохранить
                    </button>
                    {initialRows.length > 0 && (
                        <button type="button" onClick={onDelete} className="delete-btn">
                            Удалить таблицу
                        </button>
                    )}
                    <button type="button" onClick={onClose} className="cancel-btn">
                        Отмена
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConversionModal;